import { Component, OnInit } from '@angular/core';

import Swal from 'sweetalert2';
import { ssApiService } from 'app/services/ss-api.service';

import { xToastr, ToastrTypes } from 'app/shared/Toastr';

import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { UnfunishedOrderData } from 'app/models/ss-api/responses/unfinished.order.data';
import { FinishOrderRequest } from 'app/models/ss-api/requests/finish.order.request';
import { GlobalServices } from 'app/services/global.service';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface ICompleteOrderDialogModel {
    UFOID: string;
    fromLogin: boolean;
}

@Component({
    selector: 'complete-order-dialog',
    styleUrls: ['./complete-order-dialog.component.scss'],
    templateUrl: './complete-order-dialog.component.html'
})
export class CompleteOrderDialogComponent implements OnInit, ICompleteOrderDialogModel {

    IsBusy: boolean = false;

    UFOID: string;
    fromLogin: boolean = false;
    OrderData: UnfunishedOrderData = new UnfunishedOrderData();


    //
    ccLastFour: any = '3497';
    ccFirstName: string = '';
    ccLastName: string = '';
    Initals: string = '';
    DialogOrderForm: UntypedFormGroup;

    formProductClass: string;

    Year: number = new Date().getFullYear();
    YearRange: any[] = [];

    TaxEnabled: boolean = false;
    TaxRateDisplay: string = "";
    State: string = "";
    TaxAmount: number = 0;

    result: any;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private api: ssApiService,
        private gb: GlobalServices) {

    }

    ngOnInit() {
        this.UFOID = this.config.data.UFOID;
        this.fromLogin = this.config.data.fromLogin;

        this.setUpForm();
        this.GetFormData();
    }

    close() {
        this.ref.close();
    }


    setUpForm() {

        this.DialogOrderForm = new UntypedFormGroup({

            'ccNameOnCard': new UntypedFormControl('', [Validators.required]),
            'ccNr': new UntypedFormControl('', [Validators.required, Validators.maxLength(22), Validators.minLength(13), Validators.pattern('^[0-9 \+\-\]+$')]),
            'ccExpMonth': new UntypedFormControl('01', [Validators.required]),
            'ccExpYear': new UntypedFormControl(this.Year, [Validators.required]),
            'ccCVC': new UntypedFormControl('', [Validators.required]),

            //'confirmInitials': new FormControl('', [Validators.required]),
        });

        for (let i: number = 0; i < 15; i++) {
            this.YearRange.push(this.Year + i);
        }

    }

    StripNonNumeric(strValue: string): number {

        let value = strValue.replace(/[^\d]/g, ''); // 1238

        if (value == '')
            return 0;
        else
            return <any>value;

    }

    GetFinishOrderRequest(): FinishOrderRequest {

        let result = new FinishOrderRequest();
        
        result.OrderFormVersion = this.gb.OrderFormVersion;
        
        result.UFOID = this.UFOID;

        // credit card names
        let ccNameOnCard = this.DialogOrderForm.get('ccNameOnCard').value;

        // credit card expiration month
        let ccExpMonth = this.DialogOrderForm.get('ccExpMonth');
        if (ccExpMonth == undefined)
            throw RangeError('Credit Card Expiration Month Value Error');

        // credit card expiration year
        let ccExpYear = this.DialogOrderForm.get('ccExpYear');
        if (ccExpYear == undefined)
            throw RangeError('Credit Card Expiration Year Value Error');



        // - credit card
        let name = this.DialogOrderForm.get('ccNameOnCard').value;
        result.CC_FirstName = this.getFirstNameOnCard(name);
        result.CC_LastName = this.getLastNameOnCard(name);
        result.CC_Number = this.DialogOrderForm.get('ccNr').value;
        result.CC_Number = this.StripNonNumeric(result.CC_Number).toString();
        result.CC_ExpMonth = ccExpMonth.value;
        result.CC_ExpYear = ccExpYear.value - 2000;
        result.CC_CVC = this.DialogOrderForm.get('ccCVC').value;

        if (result.CC_Number == '' ||
            result.CC_Number.length < 13)
            throw Error('Invalid Credit Card Number.');

        return result;
    }


    getFirstNameOnCard(nameString: string) {


        let namesSplit = nameString.split(' ');

        if (namesSplit.length == 0)
            return;

        let firstName = namesSplit[0];
        let lastName = '';

        if (namesSplit.length > 1) {
            for (let i = 1; i < namesSplit.length; i++) {
                if (i != 1)
                    lastName += ' ';

                lastName += namesSplit[i];
            }
        }

        return firstName;
    }

    getLastNameOnCard(nameString: string) {


        let namesSplit = nameString.split(' ');

        if (namesSplit.length == 0)
            return;

        let firstName = namesSplit[0];
        let lastName = '';

        if (namesSplit.length > 1) {
            for (let i = 1; i < namesSplit.length; i++) {
                if (i != 1)
                    lastName += ' ';

                lastName += namesSplit[i];
            }
        }

        return lastName;
    }



    // get form data with UFOID
    GetFormData() {
        this.IsBusy = true;

        let subscription = this.api.GetUnfinishedOrder(this.UFOID).subscribe(
            (response) => {
                subscription.unsubscribe();

                if (!response.Result) {
                    this.IsBusy = false;
                    return;
                }

                this.OrderData = response.Data;
                
                this.TaxEnabled = response.Data.TaxEnabled;
                this.State = response.Data.State;
                this.TaxRateDisplay = response.Data.TaxRateDisplay;
                this.TaxAmount = response.Data.TaxAmount;

                this.IsBusy = false;
            },
            (error) => {
                this.IsBusy = false;
            });

    }



    confirm() {

        if (this.DialogOrderForm.invalid) return false;

        this.IsBusy = true;

        let request: FinishOrderRequest = new FinishOrderRequest();
        
        

        try {
            this.result = true;
            request = this.GetFinishOrderRequest();
        } catch (e) {
            xToastr.ShowToast(ToastrTypes.Error, 'Validation Errors', e);
            this.result = false;
            this.IsBusy = false;
            return;
        }

        let subscription = this.api.FinishOrder(request).subscribe(
            (response) => {
                subscription.unsubscribe();

                if (!response.Result) {
                    this.GetFormData();
                    this.IsBusy = false;
                    xToastr.ShowToast(ToastrTypes.Error, 'Error Processing Credit Card', 'Your Credit Card has been declined.'); // response.Message
                    this.result = false;
                    return;
                }

                // ok
                // we are logged in
                // process login
                this.gb.SetGlobalsFromLoginResponse(<any>response.Data);

                // show result
                Swal.fire(
                    {
                        title: 'Success',
                        text: 'Your account has been set up',
                        icon: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1000
                    })
                    .then(() => {
                        return new Promise((resolve, reject) => {
                            // this.router.navigate(["Dashboard"]);
                            // window.location.href = "account";
                            resolve('');
                        });
                    }, () => { }); // keep this line to prevent promise error;

                this.IsBusy = false;
                // redirect depending on where we come from
                this.IsBusy = false;

                if (this.fromLogin) {
                    // we come from login
                    window.location.href = 'account';
                } else {
                    // we come from order page
                    window.location.href = 'order-form/thank-you/';

                }

                return;
            },
            (error) => {
                this.IsBusy = false;
                return;
            });


    }

    cancel() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = false;
        this.close();
    }

    // //////////////////////////////////////
    // MISC FUNCTIONS FOR DIALOG/FORM PIECES
    // //////////////////////////////////////


    totalPrice(): number {
        let newTotal = this.OrderData.RecurringAmount + this.OrderData.SetupAmount + this.OrderData.TaxAmount;
        return newTotal;
    }


    hasLastName(): boolean {

        let ccNameOnCard = this.DialogOrderForm.get('ccNameOnCard').value;
        this.getNameOnCard(ccNameOnCard);
        if (this.ccLastName == '')
            return false;

        return true;

    }

    getNameOnCard(nameString: string) {

        this.ccFirstName = '';
        this.ccLastName = '';

        let namesSplit = nameString.split(' ');

        if (namesSplit.length == 0)
            return;

        let firstName = namesSplit[0];

        let lastName = '';

        if (namesSplit.length > 1) {
            for (let i = 1; i < namesSplit.length; i++) {
                if (i != 1)
                    lastName += ' ';

                lastName += namesSplit[i];
            }
        }

        this.ccFirstName = firstName;
        this.ccLastName = lastName;

    }


    UpdateCart() {
        // Do something here?
        
    }

    onOrderFormSubmit() {
        
    }

}
